
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  return <section className="bg-gradient-to-br from-secondary to-white py-20 px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <div className="inline-block bg-white px-4 py-1.5 rounded-full text-sm text-primary font-medium border border-primary/10 mb-2">
            DSGVO-konform auf deinen eigenen Servern
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-dark">KI-Wissensplattform für Unternehmen – Dein firmeninterner ChatGPT-Assistent</h1>
          <p className="text-grey text-lg md:text-xl leading-relaxed">
            Mitarbeiter verschwenden täglich Zeit mit der Suche nach Informationen. Unsere KI-basierte Wissensplattform durchsucht Ihr Unternehmenswissen in Sekunden und liefert Antworten in natürlicher Sprache – ob technische Dokumentation im Maschinenbau oder Sicherheitsrichtlinien in der Energiebranche.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <a href="#contact">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-white flex gap-2 items-center">
                <span>Jetzt Beratungstermin vereinbaren</span>
                <ArrowRight size={16} />
              </Button>
            </a>
            <a href="#introduction">
              <Button variant="outline" size="lg" className="border-primary text-primary hover:bg-primary/10">
                Mehr erfahren
              </Button>
            </a>
          </div>
          <div className="pt-6 flex items-center gap-3">
            <div className="bg-white p-2 rounded-full shadow-md">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z" stroke="#323CD5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 12L11 14L15 10" stroke="#323CD5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="text-grey">Datenschutz nach deutschen Standards</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="bg-white p-2 rounded-full shadow-md">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z" stroke="#323CD5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 12L11 14L15 10" stroke="#323CD5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="text-grey">Hosting auf Azure oder Stackit Cloud in Deutschland</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="bg-white p-2 rounded-full shadow-md">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z" stroke="#323CD5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 12L11 14L15 10" stroke="#323CD5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="text-grey">Volle Kontrolle über deine Daten</span>
          </div>
        </div>
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-24 h-24 bg-primary/10 rounded-full blur-2xl animate-pulse"></div>
          <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-primary/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="relative bg-white p-2 rounded-2xl shadow-custom animate-float">
            <img src="/assets/images/laptop-code.jpg" alt="KI-Chat Interface" className="w-full h-auto rounded-xl" />
            <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-white px-4 py-2 rounded-full shadow-md flex items-center gap-2">
              <span className="w-2 h-2 bg-green-500 rounded-full"></span>
              <span className="text-sm font-medium">KI-System aktiv</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};

export default Hero;
